import { Header } from "../../models/Header";

import {
  codeAct,
  collection,
  dateDebut,
  description,
  division,
  fournisseur,
  historique,
  indicateur,
  jrDemo,
  magasin,
  modele,
  nbMorceaux,
  p2,
  p2ParJour,
  planoPlateau,
  prix,
  produit,
  qte,
  reapprovisionnementAuto,
  remplacer,
  section,
  statut,
  style,
  surPlancher,
  ucc_indicateur,
  ventes,
  ventesParJour
} from "./columns";

export const headers: Header[] = [
  ucc_indicateur,
  division,
  {
    ...section,
    isDisplayed: true,
    width: "150",
    isAddOnly: false,
  },
  {
    ...magasin,
    field: "mag_nom",
    isAddOnly: false,
    isMutable: false,
  },
  {
    ...fournisseur,
    field: "four_nom",
    width: "250",
  },
  {
    ...description,
    width: "250",
  },
  {
    ...produit,
    width: "150",
  },
  {
    ...codeAct,
    width: "120",
    isMutable: true,
  },
  modele,
  {
    ...collection,
    width: "150",
    isMutable: true,
  },
  {
    ...statut,
    width: "100",
  },
  {
    ...surPlancher,
    fieldLabel: "En Magasin",
    fieldCondition: "un_magasin",
    alternativeFieldLabel: "Sur Plancher",
    width: "150",
  },
  style,
  nbMorceaux,
  prix,
  {
    ...ventes,
    width: "120",
  },
  ventesParJour,
  {
    ...qte,
    width: "80",
  },
  {
    ...p2,
    width: "80",
  },
  p2ParJour,
  {
    ...dateDebut,
    width: "120",
  },
  jrDemo,
  {
    ...historique,
    width: "150",
  },
  reapprovisionnementAuto,
  planoPlateau,
  // remplacer
];
